<template>
  <div class="wrapper">
    <h1>You are logged out!<br>Vous êtes déconnecté!</h1>
  </div>
</template>

<script>
export default {
	name: 'logout',
	methods: {
	},
	mounted: function() {
		this.$application.clearTokens();
		window.location.href=this.$application.postLogoutUrl();
	}
}
</script>

<style scoped>
	.wrapper {
		padding: 100px 50px;
	}
</style>